<script>
import router from "../../router/routes";
import NavBar from "@/components/nav-bar";
import SideBar from "@/components/side-bar";
import Footer from "@/components/footer";

export default {
  components: { NavBar, SideBar, Footer },
  beforeCreate: function () {
    document.body.className = 'main';
  },
  data() {
    return {
      isMenuCondensed: false
    };
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    }
  },
  mounted() {
    if (!document.getElementById('crm_plugin_script')) {
      const script = document.createElement('script');
      script.async = true;
      script.id = 'crm_plugin_script';
      script.src = 'https://gso.kommo.com/js/button.js';

      document.head.appendChild(script);

      script.onload = () => {
        (function (a, m1, o, c, r, m2) {
          a[m2] = {
            id: "1025285",
            hash: "e9f7507d1638e8454ee22bf359e4b0cace12740aa12920d0563ca7f533c35ba5",
            locale: "pt",
            setMeta: function (p) {
              this.params = (this.params || []).concat([p]);
            }
          };
          a[o] = a[o] || function () {
            (a[o].q = a[o].q || []).push(arguments);
          };
        }(window, 0, 'crmPlugin', 0, 0, 'crm_plugin'));
      };
    }
  }
};
</script>

<template>
  <div id="layout-wrapper">
    <NavBar :isCondensed="isMenuCondensed" />
    <SideBar :isCondensed="isMenuCondensed" />
    <div class="main-content">
      <div class="page-content">
        <div id="descontos" class="container-fluid">
          <slot />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
